// extracted by mini-css-extract-plugin
module.exports = {"left":"Chevron_left__nb2Gn","bottom":"Chevron_bottom__2dpo_","top":"Chevron_top__a2KMP"};